import axios from "axios";
import { orderPaymentGetApiUrl, paymentStatsApiUrl, ordersPaymentCRUDUrl } from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getPayments = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(orderPaymentGetApiUrl + query, config);

    return response;
};

export const getPaymentStats = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(paymentStatsApiUrl, config);

    return response;
};

export const patchOrderPayment = async (paymentId, data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(ordersPaymentCRUDUrl + paymentId + '/', data, config);

    return response;
};
